import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";

import { RestApiService } from "../shared/restApiServices/restapi.service";

@Component({
  selector: 'app-range-for-repeater-dialog',
  templateUrl: './range-for-repeater-dialog.component.html',
  styleUrls: ['./range-for-repeater-dialog.component.css']
})
export class RangeForRepeaterDialogComponent implements OnInit {

  minValue: number;
  maxValue: number;
  errMSG: String = '';
  qName="";
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
  private dialogRef: MatDialogRef<RangeForRepeaterDialogComponent>, 
  private restApiService: RestApiService) { 
    this.qName = data.qName;
  }

  ngOnInit() {
    // console.log(this.data);
  }

  onProceed() {
    if (this.data['action'] == 'enable' && this.minValue > 0 && this.maxValue > 0 && this.minValue < this.maxValue) {
      this.errMSG = '';
      this.restApiService.convertToRepeat(this.data.qID, this.minValue, this.maxValue).subscribe(result => {
        if (result && result.success) {
          this.dialogRef.close({ success: true });
        }
      })
    }
    else if (this.data['action'] == 'disable') {
      this.errMSG = '';
      this.restApiService.convertToRepeat(this.data.qID, 0, 0).subscribe(result => {
        if (result && result.success) {
          this.dialogRef.close({ success: true });
        }
      })
    }
    else {
      this.errMSG = 'Please enter valid range for your repeater form.';
    }
  }

  onCancel() {
    this.dialogRef.close({ success: false });
  }

  checkInputForNumberOnly(e) {
    // console.log(e.keyCode);
    if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode == 8) {
      if (e['srcElement']['id'] == 'minValue') {
        this.minValue = e['srcElement']['value'];
      }
      else if (e['srcElement']['id'] == 'maxValue') {
        this.maxValue = e['srcElement']['value'];
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/range-for-repeater-dialog/range-for-repeater-dialog.component.ts